
<!-- Data explorer / manager - note also refer to explorer.component.html -->

<!-- <div [ngClass]="{hidden:dataSource?.results?.pages == 1}">
    <mat-paginator #samePaginator [length]="dataSource?.results?.total"
            [pageIndex]="dataSource?.results?._currentPage"
            [pageSizeOptions]="[20, 40, 60, 100]" showFirstLastButtons></mat-paginator>
  </div> -->

<!-- File list (file name, type and size, when file last updated) -->
<div class="file_list">

  <mat-progress-bar mode="indeterminate" *ngIf="dataSource?.loading || loading"></mat-progress-bar>

  <table mat-table [dataSource]="items" class="full-width file_table" matSort>

    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->

    <tr mat-header-row *matHeaderRowDef="colNames"></tr>
    <tr [ngStyle]="i % 2 == 0 ? {'backgroundColor': 'rgba(0, 0, 0, 0.02)'} : ''" mat-row *matRowDef="let row; columns: colNames; let i = index;"></tr>

    <!-- Name Column -->
    <ng-container *ngFor="let cur of colNames;" [matColumnDef]="cur">

      <!-- All columns except the $TOOLS one -->
      <ng-container *ngIf="cur != '$TOOLS'">

        <!-- File name -->
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ (cur == 'img' || cur == 'icon') ? '' : 'FILE_LIST.HEADING.' + cur | translate }}
        </th>

        <td mat-cell *matCellDef="let element"
        (dblclick)="doubleClicked.emit(element)"
        (click)="clickedRow(element,cur)"
        readOnly="true" lightWeight="true"
        [class]="'fdm-link row-item fdm-table-col fdm-table-col-'+cur "
        [ngClass]="{
          'fdm-list-selected':selectedItemsMap[element.id],
          'cantplot':element.canPlot == null ,
          'incomplete':disableSelect || (element.incomplete && !fourD.uploadsRunningMap[element.id] )|| fourD.uploadsQueuedMap[element.id]
        }" class="row-item">

          <ng-container [ngSwitch]="cur">

            <!-- File last updated -->
            <div *ngSwitchCase="'dateUpdated'">{{ element[cur] | localDate:'!-' }}</div>

            <!-- File icon -->
            <div *ngSwitchCase="'icon'" class="datatype-icon">
              <fa-icon *ngIf="element['dataType']?.uid" [class]="element['dataType']?.uid" [icon]="'ICON.' + (element['dataType']?.uid || 'UNKNOWN') | translate"></fa-icon>
              <fa-icon *ngIf="!element['dataType']?.uid" icon="question"></fa-icon>
            </div>

            <!-- File type -->
            <div *ngSwitchCase="'dataType'">
              {{ 'TYPES.' + (element['dataType']?.uid || 'UNKNOWN') | translate }}
            </div>

            <!-- File size -->
            <div *ngSwitchCase="'size'">
              <div *ngIf="fourD.uploadsRunningMap[element.id]">
                {{ fourD.uploadsRunningMap[element.id].progress | percent }} %
              </div>

              <!-- File status -->
              <div *ngIf="element.incomplete && !fourD.uploadsRunningMap[element.id]">
                {{ 'TYPES.INCOMPLETE' | translate }} - {{ element.incomplete_offset / element.size | percent }} %
              </div>
              <div *ngIf="!element.incomplete && !fourD.uploadsRunningMap[element.id]">
                {{ element[cur] ? (element[cur] | formatFileSize) : 'TYPES.UNKNOWN' | translate }}
              </div>
            </div>

            <div *ngSwitchCase="'name'">

              {{ element[cur] }}

              <!-- [{{ element['dataType']?.uid }}] [{{ 'ICON.' + (element['dataType']?.uid || 'UNKNOWN') }}] -->
              <!-- <textarea style="width:90%;height:200px;font-size:9px;">{{ element | json }}</textarea> -->

              <div *ngIf="element.fails" class="queued">
                <fa-icon icon="exclamation-triangle" class="text-danger" [matTooltip]="element.fails"></fa-icon> {{ 'DIALOG.ERROR' | translate }}
              </div>
              <div *ngIf="element.status?.length" class="queued">
                <fa-icon icon="exclamation-triangle" class="text-warning" [matTooltip]="element.desc"></fa-icon> {{ element.status }}
              </div>
              <div *ngIf="fourD.runningTasksMap[element.id]" class="processing">
                <!-- if status is not queued then show the real status in  UI-->
                <i *ngIf="fourD.runningTasksMap[element.id].status !== 'queued'" [class]="fourD.runningTasksMap[element.id].status" translate>{{ 'PROCESSING.' + fourD.runningTasksMap[element.id].name }}</i>
                <!-- if status is queued then show Queued in  UI-->
                <i *ngIf="fourD.runningTasksMap[element.id].status === 'queued'" [class]="fourD.runningTasksMap[element.id].status" translate>{{ 'PROCESSING.TASK_QUEUED' }}</i>
              </div>
              <div *ngIf="fourD.uploadsRunningMap[element.id]" class="uploading">
                <i [class]="fourD.uploadsRunningMap[element.id].status" translate>{{ 'PROCESSING.' + fourD.uploadsRunningMap[element.id].name }}</i> <button mat-icon-button (click)="fourD.uploadsRunningMap[element.id].uploader.cancel()"><fa-icon icon="times-circle"></fa-icon></button>
              </div>
              <div *ngIf="fourD.uploadsQueuedMap[element.id]" class="queued">
                <i [class]="fourD.uploadsQueuedMap[element.id].status" translate>{{ 'PROCESSING.QUEUED' }}</i>
              </div>
            
            </div>

            <div *ngSwitchCase="'img'">
              <div class="abs_icon" vlink="image.png" [model]="element" *ngIf="!(fourD.uploadsRunningMap[element.id] || fourD.runningTasksMap[element.id] || fourD.uploadsRunningMap[element.id]) && element['dataType'] && element['dataType']['uid'] == 'photo'">
              </div>
              <div class="abs_icon" vlink="image.png?rand=ul" [model]="element" *ngIf="fourD.uploadsRunningMap[element.id] || fourD.runningTasksMap[element.id]">
                <mat-progress-spinner *ngIf="fourD.runningTasksMap[element.id]" [value]="fourD.runningTasksMap[element.id].progress * 100" [diameter]="35" [mode]="fourD.runningTasksMap[element.id].progress?'determinate':'indeterminate'"></mat-progress-spinner>
                <mat-progress-spinner *ngIf="fourD.uploadsRunningMap[element.id]" [value]="fourD.uploadsRunningMap[element.id].progress * 100" [diameter]="35" [mode]="fourD.uploadsRunningMap[element.id].progress?'determinate':'indeterminate'" color="warn"></mat-progress-spinner>
              </div>
              <div class="abs_icon" *ngIf="fourD.uploadsQueuedMap[element.id]">
                <i class="fa fa-clock-o fa-2x"></i>
              </div>
            </div>

            <div *ngSwitchDefault>{{element[cur]}}</div>

          </ng-container>

        </td>
      </ng-container>

      <!-- $TOOLS column, if it has been injected -->
      <ng-container *ngIf="cur == '$TOOLS'">
        <th mat-header-cell *matHeaderCellDef ></th>
        <td mat-cell *matCellDef="let element"  [ngClass]="{'fdm-list-selected':selectedItemsMap[element.id]}" class="fdm-table-col fdm-table-col--TOOLS">

          <button *ngIf="element.account.id != fourD.sampleAccount.id && element.status != 'processing' && element.status != 'failed' && !element['canPlot'] && element?.dataType?._adhocTransforms.length == 1" mat-raised-button color="primary" (click)="startAdHoc.emit([element,element?.dataType._adhocTransforms[0]])">{{ 'API.START' | translate }}</button>
      
          <button *ngIf="moreMenu && selectedItemsMap[element.id]" mat-icon-button [matMenuTriggerFor]="moreMenu">
            <fa-icon icon="ellipsis-v"></fa-icon>
          </button>
          
        </td>
      </ng-container>

    </ng-container>

  </table>

</div>

<div [ngClass]="{hidden:dataSource?.results?.pages == 1}"  class="stick_bottom">
  <mat-paginator #samePaginator [length]="dataSource?.results?.total"
          [pageIndex]="dataSource?.results?._currentPage"
          [pageSizeOptions]="[20, 40, 60, 100]" showFirstLastButtons></mat-paginator>
</div>
